import React, { useState, Fragment } from 'react'
import moment from 'moment'
import { Switch, message } from 'antd'
import { Link } from 'react-router-dom'
import { changeStatusBrandRulePage } from '../../../../services/api/apiBrands'
import { canViewStoreName as checkStoreName } from '../../../../services/StorageServices'



const TableRow = ({ item, listBrandsRule }) => {
    const { brand, order_tags, order_type, products, tags, created_at, updated_at, priority } = item
    const canViewStoreName = checkStoreName()
    const { exc, inc } = Object.assign({}, order_tags)
    const { packaging, branding } = Object.assign({}, tags)

    const [isShow, setIsShow] = useState(false)
    const [status, setStatus] = useState(item.is_active || false)
    const [loadingStatus, setLoadingStatus] = useState(false)

    const _handleChangeShow = () => {
        setIsShow(!isShow)
    }

    const handleChangeStatusRule = async () => {
        setLoadingStatus(true)
        setStatus(!status)
        try {
            const { data } = await changeStatusBrandRulePage(item._id, { is_active: !status })
            const {success, measage: mess} = data

            if(!success) throw new Error(mess)

            message.success('Update status successfully!')

        } catch (e) {
            message.error(e.message)
        }finally{
            setLoadingStatus(false)
        }
    }

    const _handleShowMore = text => {
        if (!text) return

        const strProductTypes = text.join(", ")

        if (!isShow && strProductTypes.length > 70) {
            return (
                <Fragment>
                    <span>{isShow ? strProductTypes : strProductTypes.substr(0, 70) + '...'}</span>
                    <small className="float-right text-primary cursor-pointer" style={{ lineHeight: '22px' }} onClick={_handleChangeShow}>show more</small>
                </Fragment>
            )
        }

        if (isShow && strProductTypes.length > 70) {
            return (
                <Fragment>
                    <span>{isShow ? strProductTypes : strProductTypes.substr(0, 70)}</span>
                    <small className="float-right text-primary cursor-pointer" onClick={_handleChangeShow}>show less</small>
                </Fragment>
            )
        }

        if (strProductTypes.length <= 100) {
            return (
                <span>{strProductTypes}</span>
            )
        }
    }

    return (
        <tr className='TableRow'>
            <td className='Priority'>{priority >= 0 ? priority : "-"}</td>
            {canViewStoreName && <td className="Store">
                <div>{brand.store || ''}</div>
                <div>{brand.name || ''}</div>
            </td>}
            <td className="ProductType">{_handleShowMore(products)}</td>
            <td className="BrandRule">
                <div>
                    {
                        !!branding && branding.length &&
                        <Fragment>
                            <span className='font-weight-bold'>Branding - </span>
                            {
                                branding.map((item, index) => (
                                    <span key={item._id}>{index ? `, ${item.name}` : item.name}</span>
                                ))
                            }
                        </Fragment>
                    }
                </div>
                <div>
                    {
                        !!packaging && packaging.length &&
                        <Fragment>
                            <span className='font-weight-bold'>Packaging - </span>
                            {
                                packaging.map((item, index) => (
                                    <span key={item._id}>{index ? `, ${item.name}` : item.name}</span>
                                ))
                            }
                        </Fragment>
                    }
                </div>
            </td>
            <td className="OrderType">
                {order_type.length > 1 ? "All" : (
                    order_type[0] === "fba" ? "FBA Order" : "Normal Order"
                )}
            </td>
            <td className="OrderTag">
                {inc.length ?
                    <Fragment>
                        <span className='d-block font-weight-bold'>{inc.join(", ")}</span>
                    </Fragment>
                    : ""
                }
                {exc.length ?
                    <Fragment>
                        <span className='d-block font-weight-bold text-danger'>{exc.join(", ")}</span>
                    </Fragment>
                    : ""
                }
                {
                    exc.length === 0 && inc.length === 0 && <span className='d-block'>All</span>
                }
            </td>
            <td className="Time">
                <div>{moment(created_at).format("HH:mm DD/MM/YYYY")}</div>
                <div>{moment(updated_at).format("HH:mm DD/MM/YYYY")}</div>
            </td>
            <td className="Status"><Switch checked={status} onChange={handleChangeStatusRule} disabled={loadingStatus}/></td>
            <td className="Action">
                <Link to={`/brands-rule/${item._id}`}>Edit</Link>
            </td>
        </tr>
    )
}

export default TableRow